import dayjs from "dayjs";
import moment from "moment";
export function convertToLocalTime(date, time) {
  // Combine date and time into a single ISO 8601 string
  const utcDateStr = `${date}T${time}Z`;
  const utcDate = new Date(utcDateStr);

  // Convert to local date and time
  const localDateObj = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000);

  // Local date as YYYY-MM-DD
  const localDateStr = localDateObj.toISOString().split("T")[0];

  // Local time as HH:MM
  const localTimeStr = localDateObj.toISOString().split("T")[1].substring(0, 5);

  // Calculate day difference
  const inputDateObj = new Date(date); // Convert input date string to Date object
  const diffInMs = localDateObj - inputDateObj;
  const dayDifference = diffInMs / (1000 * 60 * 60 * 24); // Convert milliseconds to days

  return { date: localDateStr, time: localTimeStr, dayDifference };
}

export function convertSlotToLocalTime(data, currentDate) {
  const tempData = data?.map((x) => {
    const startDate = convertToLocalTime(x.date, x.start);
    const endDate = convertToLocalTime(x.date, x.end);
    return {
      ...x,
      localDate: startDate.date,
      localStart: startDate.time,
      localEnd: endDate.time,
    };
  });
  const finalData = tempData?.filter((x) => x.localDate === currentDate);
  console.log(finalData, "finalData");
  return finalData;
}

export async function groupById(arr, key) {
  return await arr.reduce((acc, obj) => {
    if (!acc[obj[key]]) {
      acc[obj[key]] = [];
    }
    acc[obj[key]].push(obj);
    return acc;
  }, {});
}

export function getUniqueObjects(arr = []) {
  let output = arr.filter((obj, index, arr) => {
    return (
      arr.findIndex((o) => {
        return JSON.stringify(o) === JSON.stringify(obj);
      }) === index
    );
  });
  return output;
}

export function openLinkInNewTab(url) {
  window.open(url, "_blank");
}

export const dateFormatList = [
  "DD/MM/YYYY",
  // "DD/MM/YY",
  "DD-MM-YYYY",
  // "DD-MM-YY",
];

export function convertToDate(dateString) {
  // Try different date formats
  const formats = dateFormatList;

  for (let format of formats) {
    const parsedDate = dayjs(dateString, format);
    if (parsedDate.isValid()) {
      console.log(parsedDate.toDate(), "parsedDate.toDate()");
      return dayjs(parsedDate.toDate()); // Convert to native Date object
    }
  }

  // Return null if no valid date format matches
  return "";
}

export const keyFilterOption = (input, option) => {
  if (
    (option?.key ?? "").toLowerCase().includes(input.toLowerCase()) ||
    (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
  ) {
    return true;
  }
  return false;
};

export function truncateString(str, maxLength) {
  if (str?.length > maxLength) {
    return str.slice(0, maxLength) + "...";
  } else {
    return str;
  }
}

let timerId; // Global variable to store the interval ID

export function startStopwatch(sessionData, callback) {
  const {
    sessionStartTime,
    elapsedSessionTime,
    maxDuration, // includes duration
  } = sessionData;

  if (timerId) {
    clearInterval(timerId);
  }

  const startTime = new Date(sessionStartTime);
  const currentTime = new Date();

  let remainingTime;

  if (!elapsedSessionTime) {
    // Case 1: Calculate from current time to session end
    const endTime = new Date(startTime.getTime() + maxDuration * 60000);
    remainingTime = Math.max(0, Math.floor((endTime - currentTime) / 1000)); // in seconds
  } else {
    // Case 2: Use elapsed time to compute remaining
    const usedMinutes = Math.floor(elapsedSessionTime); // already in minutes
    remainingTime = Math.max(0, (maxDuration - usedMinutes) * 60); // Convert remaining minutes to seconds
  }

  // Update the timer
  function updateTimer() {
    if (remainingTime <= 0) {
      callback("00:00");
      clearInterval(timerId); // Clear the interval when time is up
      timerId = null; // Reset the interval ID
      return;
    }

    const minutes = Math.floor(remainingTime / 60);
    const seconds = remainingTime % 60;

    const formattedTime = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

    remainingTime--;
    callback(formattedTime);
  }

  timerId = setInterval(updateTimer, 1000); // Start a new interval
}

export const DAYS = [
  {
    label: "Monday",
    value: "monday",
  },
  {
    label: "Tuesday",
    value: "tuesday",
  },
  {
    label: "Wednesday",
    value: "wednesday",
  },
  {
    label: "Thursday",
    value: "thursday",
  },
  {
    label: "Friday",
    value: "friday",
  },
  {
    label: "Saturday",
    value: "saturday",
  },
  {
    label: "Sunday",
    value: "sunday",
  },
];

export function convertToUTC(date, time) {
  const localDateStr = `${date}T${time}Z`;
  const localDate = new Date(localDateStr);
  const offset = localDate.getTimezoneOffset(); // Difference between local time and UTC in minutes
  const utcDate = new Date(localDate.getTime() + offset * 60000);

  // UTC date and day
  const utcDateStr = utcDate.toISOString().split("T")[0];
  const utcDayStr = utcDate.toUTCString().split(",")[0]; // Extracts weekday from UTC string

  // Calculate day difference
  const localDateObj = new Date(date); // Convert local date string to Date object
  const diffInMs = utcDate - localDateObj;
  const dayDifference = diffInMs / (1000 * 60 * 60 * 24); // Convert milliseconds to days

  // UTC time
  const utcTime = utcDate.toISOString().split("T")[1].substring(0, 5); // HH:MM format

  return { date: utcDateStr, time: utcTime, dayDifference };
}

export function convertSlotsToUTC(slots) {
  return slots.map((slot) => {
    const startUTC = convertToUTC(moment().format("YYYY-MM-DD"), slot.start);
    const endUTC = convertToUTC(moment().format("YYYY-MM-DD"), slot.end);

    return {
      start: startUTC.time,
      end: endUTC.time,
      dayDifference: startUTC.dayDifference,
    };
  });
}

const excludedFields = ["lastName", "otherContacts", "universityName", "courseName"];

const isEmpty = (value) => {
  if (value === null || value === undefined || value === "") {
    return true; // Null, undefined, or empty string
  }
  if (Array.isArray(value)) {
    if (value.length === 0) {
      return true; // Empty array
    }
    // Check for empty objects inside arrays
    return value.every((item) => isEmpty(item));
  }
  if (typeof value === "object" && value !== null && Object.keys(value).length === 0) {
    return true; // Empty object
  }
  return false; // All other cases are not empty
};

export const getMissingFields = (obj) => {
  const missing = [];
  Object.keys(obj).forEach((key) => {
    if (!excludedFields.includes(key) && isEmpty(obj[key])) {
      missing.push(key);
    }
  });
  return missing;
};
